import { ReactNode } from "react";
import { BiHome } from "react-icons/bi";
import { FaRegFileAlt } from "react-icons/fa";
import { LuUser } from "react-icons/lu";
import { MdHelpOutline, MdHistory, MdOutlineReceipt } from "react-icons/md";

export interface NavItem {
  label: string;
  to: string;
  icon: ReactNode;
  id: string;
}

export const menuItems: NavItem[] = [
  {
    label: "Início",
    to: "/cliente",
    icon: <BiHome size={24} className="text-n-text-primary" />,
    id: "inicio",
  },
  {
    label: "Resumo",
    to: "/cliente/resumo",
    icon: <MdOutlineReceipt size={24} className="text-n-text-primary" />,
    id: "resumo",
  },
  {
    label: "Dados pessoais",
    to: "/cliente/dados-pessoais",
    icon: <LuUser size={24} className="text-n-text-primary" />,
    id: "dados-pessoais",
  },
  {
    label: "Cotações em aberto",
    to: "/cliente/cotacoes-abertas",
    icon: <FaRegFileAlt size={24} className="text-n-text-primary" />,
    id: "cotacoes-abertas",
  },
  {
    label: "Histórico",
    to: "/cliente/contratos",
    icon: <MdHistory size={24} className="text-n-text-primary" />,
    id: "contratos",
  },
  {
    label: "Ajuda",
    to: "/cliente/ajuda/perguntas-frequentes",
    icon: <MdHelpOutline size={24} className="text-n-text-primary" />,
    id: "central-ajuda",
  },
];
